var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("div", { staticClass: "statistics-container" }, [
        _c("div", { staticClass: "statistic-card card-danger" }, [
          _c(
            "div",
            {
              staticClass: "statistic-value",
              staticStyle: { color: "#f56c6c" },
            },
            [_vm._v(_vm._s(_vm.topData.exceptionTotal))]
          ),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(_vm._s(_vm.$t("ExternalOrders.page.exceptionLabel"))),
          ]),
        ]),
        _c("div", { staticClass: "statistic-card card-primary" }, [
          _c("div", { staticClass: "statistic-value" }, [
            _vm._v(_vm._s(_vm.topData.processingTotal)),
          ]),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(_vm._s(_vm.$t("ExternalOrders.page.processingLabel"))),
          ]),
        ]),
        _c("div", { staticClass: "statistic-card card-success" }, [
          _c("div", { staticClass: "statistic-value" }, [
            _vm._v(_vm._s(_vm.topData.writeBackTotal)),
          ]),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(
              _vm._s(_vm.$t("ExternalOrders.page.processingStatusWriteback"))
            ),
          ]),
        ]),
        _c("div", { staticClass: "statistic-card card-gray" }, [
          _c("div", { staticClass: "statistic-value" }, [
            _vm._v(_vm._s(_vm.topData.unCapturedTotal)),
          ]),
          _c("div", { staticClass: "statistic-label" }, [
            _vm._v(
              _vm._s(_vm.$t("ExternalOrders.page.processingStatusUncaptured"))
            ),
          ]),
        ]),
      ]),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "get-action": _vm.queryApi,
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t(
                                "BusinessAfterCsgReturn.table.cusName"
                              ),
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.clientCodeList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              on: { change: _vm.handleClientCodeChange },
                              model: {
                                value: _vm.queryParams.clientCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "clientCode", $$v)
                                },
                                expression: "queryParams.clientCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("BjSelectChannelStore", {
                  attrs: {
                    span: _vm.colSpan,
                    "query-params": _vm.queryParams,
                    "query-keys": ["channelTypeCode", "storeId"],
                  },
                  on: {
                    handleChannelChange: _vm.handleChannelChange,
                    handleStoreChange: _vm.handleStoreChange,
                  },
                }),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ExternalOrders.page.orderIdLabel"),
                          prop: "orderId",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ExternalOrders.page.orderIdLabel"
                            ),
                            disabled: !_vm.queryParams.channelTypeCode,
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.orderId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "orderId", $$v)
                            },
                            expression: "queryParams.orderId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ExternalOrders.page.orderStatusLabel"),
                          prop: "orderStatus",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "full-width",
                            attrs: {
                              placeholder: _vm.$t(
                                "ExternalOrders.page.orderStatusLabel"
                              ),
                              clearable: "",
                              disabled: !_vm.queryParams.channelTypeCode,
                            },
                            model: {
                              value: _vm.queryParams.orderStatus,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "orderStatus", $$v)
                              },
                              expression: "queryParams.orderStatus",
                            },
                          },
                          _vm._l(_vm.orderStatusList, function (item) {
                            return _c(
                              "el-option",
                              {
                                key: item.label,
                                attrs: { label: item.label, value: item.value },
                              },
                              [_c("span", [_vm._v(_vm._s(item.label))])]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "ExternalOrders.page.processingStatusLabel"
                          ),
                          prop: "processingStatus",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ExternalOrders.page.processingStatusLabel"
                            ),
                            "option-list": _vm.PROCESSING_STATUS_LIST,
                            disabled: !_vm.queryParams.channelTypeCode,
                          },
                          model: {
                            value: _vm.queryParams.processingStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "processingStatus", $$v)
                            },
                            expression: "queryParams.processingStatus",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("ExternalOrders.page.eligibleLabel"),
                          prop: "eligible",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "ExternalOrders.page.eligibleLabel"
                            ),
                            "option-list": _vm.ELIGIBLE_LIST,
                            disabled: !_vm.queryParams.channelTypeCode,
                          },
                          model: {
                            value: _vm.queryParams.eligible,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "eligible", $$v)
                            },
                            expression: "queryParams.eligible",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    col.prop == "clientCode"
                                      ? [
                                          _vm._v(
                                            _vm._s(
                                              _vm.clientCodeList.bjGet(
                                                scope.row.clientCode
                                              )
                                            )
                                          ),
                                        ]
                                      : col.prop === "orderStatus"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                scope.row.orderStatus == "open"
                                                  ? "success"
                                                  : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.orderStatus)
                                            ),
                                          ]
                                        )
                                      : col.prop === "paymentStatus"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                scope.row.paymentStatus ==
                                                "paid"
                                                  ? "success"
                                                  : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row.paymentStatus
                                                  ? scope.row.paymentStatus
                                                  : "N/A"
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "processingStatus"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                scope.row.processingStatus !=
                                                "Exception"
                                                  ? "success"
                                                  : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.PROCESSING_STATUS_LIST.bjGet(
                                                    scope.row.processingStatus
                                                  )
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : col.prop === "eligible"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                scope.row.eligible == "Yes"
                                                  ? "success"
                                                  : "info",
                                            },
                                          },
                                          [_vm._v(_vm._s(scope.row.eligible))]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    props.row.processingStatus == "Exception"
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "edit-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onView(props.row)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$t("viewText")))]
                                        )
                                      : _vm._e(),
                                    props.row.processingStatus == "Exception"
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onRetry(props.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "ExternalOrders.page.retryBtn"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    props.row.processingStatus == "Uncaptured"
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onPull(props.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "ExternalOrders.page.pullBtn"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          staticClass: "exception-dialog",
          attrs: {
            visible: _vm.exceptionDialogVisible,
            width: "600px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.exceptionDialogVisible = $event
            },
          },
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _c("i", {
              staticClass: "el-icon-warning",
              staticStyle: { color: "#f56c6c", "margin-right": "6px" },
            }),
            _c(
              "span",
              { staticStyle: { "font-size": "16px", "font-weight": "600" } },
              [_vm._v(_vm._s(_vm.$t("ExternalOrders.page.dialogTitle")))]
            ),
          ]),
          _c("div", { staticClass: "exception-content" }, [
            _c("div", { staticClass: "exception-title" }, [
              _c("span", [
                _vm._v(
                  "Order " +
                    _vm._s(_vm.currentRow.platformOrderNo) +
                    " — " +
                    _vm._s(_vm.clientCodeList.bjGet(_vm.currentRow.clientCode))
                ),
              ]),
            ]),
            _c("div", { staticClass: "exception-message" }, [
              _c("div", { staticClass: "message-label" }, [
                _vm._v(_vm._s(_vm.$t("ExternalOrders.page.errorMessageLabel"))),
              ]),
              _c("div", { staticClass: "message-text" }, [
                _vm._v(_vm._s(_vm.currentRow.exceptionReason)),
              ]),
            ]),
            _c("div", { staticClass: "exception-tip" }, [
              _vm._v(
                " " + _vm._s(_vm.$t("ExternalOrders.page.dialogTip")) + " "
              ),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.exceptionDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("ExternalOrders.page.closeBtn")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleRetryFromDialog },
                },
                [_vm._v(_vm._s(_vm.$t("ExternalOrders.page.retryBtn")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }